import { doc, DocumentReference } from 'firebase/firestore';
import { docData } from 'rxfire/firestore';
import { Observable } from 'rxjs';
import { map, switchMap } from 'rxjs/operators';
import { getPredefinedDateRange } from '../../../../utils/date';
import { IRange, ISelectableTag, IUser } from '../../../types';
import { authenticatedUserProvider } from '../../userProvider';

export interface IDsiReportSettings {
  cmjTags: ISelectableTag[];
  isoTags: ISelectableTag[];
  timeframe: IRange;
}

const defaultSettings: IDsiReportSettings = {
  cmjTags: [],
  isoTags: [
    {
      label: 'Mid-Thigh Pull',
      value: 'Fwa589fw7X9pA20tenz4',
      entity: {
        active: true,
        default: true,
        exclude_weight: true,
        name: 'Mid-Thigh Pull',
        id: 'Fwa589fw7X9pA20tenz4',
        description: '',
      },
    },
  ],
  timeframe: getPredefinedDateRange('year'),
};

/**
 * @description observes dashboard settings
 */
export const dsiReportSettingsProvider = (): Observable<IDsiReportSettings> => {
  return authenticatedUserProvider().pipe(
    switchMap((user: IUser): Observable<IDsiReportSettings> => {
      return docData(
        doc(
          user.services.firestore,
          `userProfiles/${user.id}/settings/dsiReport`
        ) as DocumentReference<IDsiReportSettings>
      ).pipe(
        map((settings: IDsiReportSettings): IDsiReportSettings => {
          return { ...defaultSettings, ...settings };
        })
      );
    })
  );
};
